<template>
  <div>
    <b-col v-if="loading">
      <b-skeleton
        animation="wave"
        class="mx-auto"
        width="60%"
        height="100px"
      />
      <b-skeleton
        animation="wave"
        class="mx-auto"
        width="60%"
        height="200px"
      />
    </b-col>
    <section v-else>
      <scroll-container
        class="pt-2 mt-n30px"
        height-offset="140px"
      >
        <b-container
          class="container-small"
        >
          <b-card
            class="mb-2 p-2"
            no-body
          >
            <b-form-group
              class="mb-0"
              :label="$tk('ClientPortal.Form.NameOfPlacement') + ' *'"
              label-for="input-ad-group-name"
              :state="adGroupNameValidate"
            >
              <b-form-input
                id="input-ad-group-name"
                v-model="wrapper.placementModel.name"
                :placeholder="$tk('ClientPortal.Form.NameOfPlacementPlaceholder')"
                :state="adGroupNameValidate"
              />
              <span
                v-if="wrapper.placementModel.errorMessage"
                class="field-validation-valid text-danger small"
              >{{ wrapper.placementModel.errorMessage }}</span>
              <span
                v-if="errorMessages['Name']"
                class="field-validation-valid text-danger small"
              >{{ errorMessages['Name'] }}</span>
              <span
                v-if="errorMessages['property']"
                class="field-validation-valid text-danger small"
              >{{ errorMessages['property'] }}</span>
            </b-form-group>
            <div class="my-2">
              <template
                v-if="!wrapper.placementModel.id"
                class="mb-2"
              >
                <b-card-text>
                  {{ $tk('ClientPortal.Form.ChooseTypeOfAd') }} *
                  <GjIcon
                    v-b-tooltip.hover="$tk('ClientPortal.Placements.ChooseTypeOfAdInfo')"
                    name="Info"
                  />
                </b-card-text>
                <b-row
                  v-if="!wrapper.placementModel.id"
                  class="mx-n25"
                >
                  <b-col
                    v-for="adType in wrapper.adTypes"
                    :key="adType.id"
                    class="px-25"
                  >
                    <b-card
                      class="text-center border cursor-pointer mb-1"
                      :class="getAdTypeButtonClass(adType.id)"
                      @click="setTypeOfAd(adType)"
                    >
                      <GjIcon
                        class="mb-50"
                        :name="getAdTypeIconTemporarily(adType)"
                        size="30px"
                      />
                      <small class="d-block">
                        {{ adType.name }}
                      </small>
                    </b-card>
                  </b-col>
                </b-row>
              </template>
              <b-card-text
                v-if="wrapper.placementModel.adType != 0"
                class="mt-2"
              >
                {{ $tk('ClientPortal.Form.Format') }} *
                <GjIcon
                  v-b-tooltip.hover="$tk('ClientPortal.Placements.FormatInfo')"
                  name="Info"
                />
              </b-card-text>
              <ul
                id="ad-formats"
                class="mb-n1"
              >
                <template v-for="(adFormat, index) in wrapper.adFormats">
                  <li
                    v-if="adFormat.adType == wrapper.placementModel.adType"
                    :key="index"
                    class="mr-3 mb-1"
                  >
                    <b-form-checkbox
                      v-if="adFormat.adType !== 3"
                      v-model="adFormat.checked"
                      @change="addPlacementFormat(adFormat)"
                    >
                      {{ adFormat.name }}
                    </b-form-checkbox>
                    <b-form-radio
                      v-else
                      v-model="adFormat.checked"
                      :checked="adFormat.checked"
                      :value="adFormat.checked ? adFormat.checked : '' "
                      @change="addPlacementFormat(adFormat), adFormat.checked = !adFormat.checked"
                    >
                      {{ adFormat.name }}
                    </b-form-radio>
                  </li>
                </template>
              </ul>
              <span
                v-if="errorMessages['PlacementFormat']"
                class="field-validation-valid text-danger small"
              >
                {{ errorMessages['PlacementFormat'] }}
              </span>
            </div>
            <div
              v-if="isProductAd"
            >
              <div class="row justify-content-between mx-auto mb-50">
                <div
                  v-if="wrapper.placementModel.adType != 0"
                  class="mt-2 card-text"
                >
                  {{ $tk('ClientPortal.Form.Template') }} *
                  <GjIcon
                    name="Info"
                  />
                </div>
                <div class="mt-2">
                  <b-link
                    :to="`/${$route.params.accountId}/nativeadtemplate`"
                    class="link-text"
                  >
                    <GjIcon
                      size="14"
                      name="Plus"
                    />
                    <span class="create-text">{{ $tk('ClientPortal.Form.ManageTemplates') }}</span>
                  </b-link>
                </div>
              </div>
              <b-form-group class="mb-2">
                <multiselect
                  v-model="wrapper.placementModel.nativeAdTemplate"
                  :options="templates"
                  label="name"
                  track-by="id"
                  :group-select="false"
                  :multiple="false"
                  group-label="label"
                  select-label=""
                  selected-label=""
                  deselect-label=""
                  group-values="templates"
                  @select="(selectedOption, id) => changeTemplate(selectedOption)"
                >
                  <template slot="placeholder">
                    <span class="multiselect__placeholder mb-0">{{ $tk('ClientPortal.Form.SelectTemplate') }}</span>
                  </template>
                  <template slot="noOptions">
                    {{ $tk('ClientPortal.Form.NoTemplates') }}
                  </template>
                  <template
                    slot="caret"
                    slot-scope="{ toggle }"
                  >
                    <div
                      class="multiselect__select"
                      @mousedown.prevent.stop="toggle()"
                    >
                      <GjIcon
                        class="icon-wrapper"
                        name="ArrowDown_fill"
                        size="21"
                      />
                    </div>
                  </template>
                </multiselect>
                <span
                  v-if="errorMessages['NativeAdTemplate']"
                  class="field-validation-valid text-danger small"
                >
                  {{ errorMessages['NativeAdTemplate'] }}
                </span>
              </b-form-group>
              <ad-preview
                :template="template"
                :properites="wrapper.nativeAdProperties"
              />
            </div>
            <hr v-if="wrapper.placementModel.id > 0">
            <div
              v-if="wrapper.placementModel.id > 0"
              :title="$tk('ClientPortal.Form.AdvancedOptions')"
              class="mb-2"
            >
              <b-form-group
                v-if="wrapper.placementModel.adType != 0 && platformAccessManager.canSeeAllProperties()"
                class="pb-25"
              >
                <label class="col-form-label pt-0">
                  {{ $tk('ClientPortal.Form.BidStrategy') }}
                  <GjIcon
                    v-b-tooltip.hover="$tk('ClientPortal.Placements.BidStrategyInfo')"
                    name="Info"
                  />
                </label>
                <b-list-group
                  class="mb-1"
                  flush
                >
                  <b-list-group-item
                    v-for="(bidStrategyOption,index) in wrapper.placementModel.placementBidStrategyMappings"
                    :key="index"
                    class="px-0 py-25 list-item--border"
                  >
                    <b-row
                      class="mx-n25"
                    >
                      <b-col
                        class="px-25"
                        sm="6"
                      >
                        <div class="mr-1">
                          <div
                            class="px-25 pt-50"
                          >
                            <small>
                              {{ $tk('ClientPortal.Form.Strategy') }}
                            </small>
                          </div>
                          <v-select
                            v-model="bidStrategyOption.bidStrategyId"
                            :options="wrapper.bidStrategies"
                            label="name"
                            taggable
                            :clearable="false"
                            select-on-tab
                            :reduce="bid => bid.id"
                          />
                        </div>
                      </b-col>
                      <b-col
                        class="px-25"
                        sm="6"
                      >
                        <div class="row">
                          <div class="col-11 pr-0">
                            <div class="pr-1">
                              <div
                                class="px-25 pt-50"
                              >
                                <small>
                                  {{ $tk('ClientPortal.Form.StrategyValue') }}
                                </small>
                              </div>
                              <b-form-input
                                v-model.number="bidStrategyOption.bidValue"
                                type="number"
                                required
                                :state="bidStrategyOption.errorMessage == null ? null : false"
                              />
                            </div>
                          </div>
                          <div class="col-1 px-0">
                            <b-button
                              class="p-0 delete-bid-button"
                              variant="link"
                              size="sm"
                              @click="removePlacementBidding(index)"
                            >
                              <GjIcon
                                class="cursor-pointer"
                                name="Delete"
                              />
                            </b-button>
                          </div>
                        </div>
                      </b-col>
                      <span
                        v-if="bidStrategyOption.errorMessage"
                        class="field-validation-valid d-block text-danger small"
                      >
                        {{ bidStrategyOption.errorMessage }}
                      </span>
                    </b-row>
                  </b-list-group-item>
                </b-list-group>
                <span
                  v-if="errorMessages['BidStrategyId']"
                  class="field-validation-valid text-danger small d-block mb-1"
                >
                  {{ errorMessages['BidStrategyId'] }}
                </span>
                <b-button
                  size="sm"
                  variant="outline-primary"
                  @click="addPlacementBidStrategy"
                >
                  <GjIcon
                    class="mr-50"
                    name="Plus"
                  />
                  {{ $tk('ClientPortal.Form.AddBidStrategy') }}
                </b-button>
              </b-form-group>
              <hr>
              <b-form-group
                v-if="wrapper.catalogs.length > 0"
                class="mb-2"
                :label="$tk('ClientPortal.Form.Catalogs')"
              >
                <MultiselectTags
                  id="catalogsInclude"
                  :included-tags="wrapper.placementModel.placementCatalogMappings"
                  :options="wrapper.catalogs"
                  :placeholder="$tk('ClientPortal.Form.SearchCatalogs')"
                  :group="false"
                  option-label="name"
                  :is-duplicating="true"
                  @addOption="addCatalog"
                  @removeOption="removeCatalog"
                />
              </b-form-group>
              <b-form-group
                v-if="wrapper.customTargetingProperties && wrapper.customTargetingProperties.length > 0"
                class="mb-0"
                :label="$tk('ClientPortal.Form.TargetingProperties')"
              >
                <MultiselectTags
                  id="targetingPropertiesInclude"
                  :included-tags="wrapper.placementModel.placementTargetingPropertyMappings"
                  :options="wrapper.customTargetingProperties"
                  :placeholder="$tk('ClientPortal.Form.SearchTargeting')"
                  :group="false"
                  option-label="name"
                  :is-duplicating="true"
                  track-by="targetingPropertyId"
                  key-by="targetingPropertyId"
                  @addOption="addTargetingProperty"
                  @removeOption="removeTargetingProperty"
                />
              </b-form-group>
            </div>
            <div v-if="wrapper.placementModel.id > 0">
              <pre
                v-if="wrapper.placementModel.adType != 2"
                id="code"
                ref="placementCode"
                class="mb-1 pt-1 px-1 bg-transparent border"
              >
&lt;div id="{{ wrapper.placementModel.name.trim().toLowerCase().replace(/\s\s+/g, ' ').replace(/\s/g, '-') }}"&gt;
    &lt;script type="text/javascript"&gt;
        window.ANConfig = window.ANConfig || {};
        window.ANConfig.placements = window.ANConfig.placements || [];

        window.ANConfig.placements.push({
            adUnitId: '{{ wrapper.placementModel.name.trim().toLowerCase().replace(/\s\s+/g, ' ').replace(/\s/g, '-') }}',
            propertyId: '{{ wrapper.placementModel.propertyId }}',
            placementId: '{{ wrapper.placementModel.id }}',
            data: {<template v-if="wrapper.placementModel.placementCatalogMappings.length > 0">
                catalogs: [<template v-for="catalog in wrapper.placementModel.placementCatalogMappings">
                    {
                        catalogId: '{{ catalog.id }}',
                        items: []
                    },</template>
                ],</template><template v-if="wrapper.placementModel.placementTargetingPropertyMappings.length > 0">
                inventory: {<template v-for="targetingProperty in wrapper.placementModel.placementTargetingPropertyMappings">
                    '{{ targetingProperty.value }}': [],</template>
                }</template>
            },
            onLoad: function (adUnitId) {
                console.log('1', adUnitId);
            },
            onFail: function (adUnitId) {
                console.log('0', adUnitId);
                //fallback code
            },
        });

        (function () {
            if (!document.getElementById('ap-js')) {
                var ver = new Date().toISOString().split(':')[0].replace(/\D/g,'');
                var apjs = document.createElement("script");
                apjs.type = "text/javascript";
                apjs.async = true;
                apjs.setAttribute('id', 'ap-js');
                apjs.src = "{{ centralApiUrl }}/js/ap-gjanout.js?v=" + ver;
                document.head.append(apjs);
            }
        })();
     &lt;/script&gt;
&lt;/div&gt;
              </pre>
              <template v-else>
                <b-card-text class="mt-1">
                  {{ $tk('ClientPortal.Form.VastUrlInfo') }}
                </b-card-text>
                <div class="vast-url-wrapper mb-1 border bg-transparent">
                  <span class="vast-url-method">GET</span>
                  <pre
                    id="code"
                    ref="placementCode"
                    class="vast-url-code mb-0 p-1 bg-transparent"
                  >{{ vastUrl }}</pre>
                </div>
                <ul class="small mb-1">
                  <li><code>adUnitId</code> — Ad unit code</li>
                  <li><code>placementId</code> — PlacementId</li>
                  <li><code>propertyId</code> — PropertyId</li>
                  <li><code>count</code> — Number of video ads to return (e.g. 2 preroll ads)</li>
                </ul>
              </template>
              <b-button
                id="btn-copy"
                size="sm"
                variant="link"
                class="btn-copy"
                data-clipboard-target="#code"
                @click="copy()"
              >
                <GjIcon
                  class="mr-50"
                  name="Copy"
                />
                {{ $tk('ClientPortal.Form.CopyToClipboard') }}
              </b-button>
            </div>
          </b-card>
        </b-container>
      </scroll-container>
      <div class="border-top text-right py-1">
        <div class="px-25 footer__buttons--align">
          <b-button
            :disabled="saving"
            class="bg-white"
            size="sm"
            variant="outline-dark"
            :to="`/${$route.params.accountId}/property/details?propertyId=${propertyId}`"
          >
            {{ $tk('Form.Actions.Cancel') }}
          </b-button>
          <b-button
            v-if="accountAccessManager.canManageProperties()"
            class="ml-50"
            size="sm"
            variant="primary"
            :disabled="saving || !isFormComplete"
            @click.prevent="savePlacement(wrapper.placementModel)"
          >
            {{ $tk('ClientPortal.Form.Actions.Save') }}
          </b-button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import Multiselect from 'vue-multiselect'
import ScrollContainer from '@/components/ScrollContainer.vue'
import AdPreview from '@/components/AdPreview.vue'
import notification from '@/mixins/toastification'
import PlacementsService from '@/api/client/placements.service'
import { PlatformAccessManager, AccountAccessManager } from '@/utils/accessManager/accessManager'
import store from '@/store'
import vSelect from 'vue-select'
import MultiselectTags from '@/views/client/ads-manager/create/MultiselectTags.vue'

// const PRODUCT_NATIVEAD_SUBTYPE_ID = 6
const PRODUCT_NATIVEAD_FORMAT_ID = 9

export default {
  components: {
    GjIcon,
    Multiselect,
    ScrollContainer,
    AdPreview,
    vSelect,
    MultiselectTags,
  },
  mixins: [notification],
  data() {
    return {
      wrapper: {},
      errorMessages: '',
      saving: false,
      toggleView: false,
      toggleCatalogMappings: false,
      toggleTargetingPropertyMappings: false,
      loading: true,
      propertyId: '',
      placementId: '',
      platformAccessManager: PlatformAccessManager,
      accountAccessManager: AccountAccessManager,
    }
  },
  computed: {
    isProductAd() {
      return this.wrapper.placementModel.placementFormatMappings.some(x => x.formatId === PRODUCT_NATIVEAD_FORMAT_ID)
    },
    templates() {
      return this.wrapper.nativeAdTemplates
    },
    adGroupNameValidate() {
      return this.wrapper.placementModel.errorMessage || this.errorMessages.Name || this.errorMessages.property ? false : null
    },
    template() {
      return this.wrapper.placementModel.nativeAdTemplate != null ? this.wrapper.placementModel.nativeAdTemplate.htmlContent : ''
    },
    centralApiUrl() {
      const raw = process.env.VUE_APP_CENTRAL_API_URL || 'https://central.gjirafa.com'
      return raw
        .replace(/^(https?:\/\/)(?:https?:\/\/)+/i, '$1')
        .replace(/\/+$/, '')
    },
    vastUrl() {
      const { name, id, propertyId } = this.wrapper.placementModel
      const adUnitId = name.trim().toLowerCase().replace(/\s\s+/g, ' ').replace(/\s/g, '-')
      return `${this.centralApiUrl}/vast?adUnitId=${adUnitId}&placementId=${id}&propertyId=${propertyId}&count=2`
    },
    isFormComplete() {
      const {
        name, adType, placementFormatMappings, nativeAdTemplate,
      } = this.wrapper.placementModel

      if (placementFormatMappings.find(x => x.formatId === PRODUCT_NATIVEAD_FORMAT_ID)) {
        return name && adType && nativeAdTemplate
      }

      return name && adType && placementFormatMappings.length
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    'wrapper.placementModel.adType': function () {
      if (this.wrapper.placementModel.id == null) { this.setAdFormatsFalse() }
    },
    '$route.params.accountId': 'onAccountChange',
    '$route.query.placementId': 'fetchData',
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.propertyId = this.$route.query.propertyId !== undefined ? this.$route.query.propertyId : ''
      this.placementId = this.$route.query.placementId !== undefined ? this.$route.query.placementId : 0
      try {
        this.wrapper = await PlacementsService.getPlacement(this.propertyId, this.placementId, this.$route.params.accountId)
        const name = this.wrapper.propertyModel?.name
        if (name && this.$route.meta.breadcrumb && this.$route.meta.breadcrumb[1]) {
          this.$set(this.$route.meta.breadcrumb[1], 'text', name)
          store.commit('verticalMenu/changeBreadcrumbs', name)
        }
      } catch (error) {
        this.error(this.$tk('ClientPortal.Form.FailedToLoadData'))
      } finally {
        this.loading = false
        this.wrapper.adFormats.forEach(element => {
          this.isFormatChecked(element)
        })
      }
    },
    addCatalog(catalog) {
      this.wrapper.placementModel.placementCatalogMappings.push(catalog)
    },
    removeCatalog(catalog) {
      const catalogIndex = this.wrapper.placementModel.placementCatalogMappings.findIndex(item => item.id === catalog.id)
      this.wrapper.placementModel.placementCatalogMappings.splice(catalogIndex, 1)
    },
    addTargetingProperty(targetingProperty) {
      this.wrapper.placementModel.placementTargetingPropertyMappings.push(targetingProperty)
    },
    removeTargetingProperty(targetingProperty) {
      const targetingPropertyIndex = this.wrapper.placementModel.placementTargetingPropertyMappings.findIndex(item => item.targetingPropertyId === targetingProperty.targetingPropertyId)
      this.wrapper.placementModel.placementTargetingPropertyMappings.splice(targetingPropertyIndex, 1)
    },
    async savePlacement(model) {
      this.saving = true
      const { accountId } = this.$route.params
      try {
        const response = await PlacementsService.createPlacement(this.propertyId, model, accountId)
        if (response.saved) {
          if (this.placementId === 0) {
            store.commit('app/TOGGLE_NEW_CREATE_STATE', true)
            this.success(this.$tk('ClientPortal.Form.PlacementCreatedSuccessfully'))
            this.$router.push(`/${accountId}/property/placement?propertyId=${this.propertyId}&placementId=${response.placementId}`)
          } else {
            this.success(this.$tk('ClientPortal.Form.PlacementUpdatedSuccessfully'))
            this.$router.push(`/${accountId}/property/details?propertyId=${this.propertyId}`)
          }
        } else {
          this.error(this.$tk('ClientPortal.Form.ErrorSavingChanges'))
          this.errorMessages = response.errors
        }
      } catch (error) {
        this.error(error.message)
      } finally {
        this.saving = false
      }
    },
    copy() {
      const placementCodeToCopy = this.$refs.placementCode.innerText
      this.$copyText(placementCodeToCopy)
      this.success(this.$tk('ClientPortal.Form.PlacementCodeCopied'))
    },
    getBidStrategyButtonClass(bidStrategyId) {
      if (bidStrategyId !== 0) {
        // const check = bidStrategyId === this.wrapper.placementModel.bidStrategyId
      } else {
        return 'btn-light'
      }
      return ''
    },
    setBidStrategy(bidStrategyId) {
      this.wrapper.placementModel.bidStrategyId = bidStrategyId
    },
    addPlacementFormat(adFormat) {
      if (this.wrapper.placementModel.adType <= 2) {
        const index = this.wrapper.placementModel.placementFormatMappings.map(placementFormat => placementFormat.formatId).indexOf(adFormat.id)
        if (index === -1) {
          this.wrapper.placementModel.placementFormatMappings.push({
            id: 0,
            formatId: adFormat.id,
          })
        } else {
          this.wrapper.placementModel.placementFormatMappings.splice(index, 1)
        }
      } else {
        this.wrapper.placementModel.placementFormatMappings = []
        const adTypeFormats = this.wrapper.adFormats.filter(x => x.adType === adFormat.adType)
        this.wrapper.placementModel.placementFormatMappings.push({
          id: 0,
          formatId: adFormat.id,
        })
        adTypeFormats.forEach(format => {
          if (format.id !== adFormat.id) {
            this.$nextTick(() => {
              this.$set(format, 'checked', false)
            })
          }
        })
      }
    },
    addPlacementBidStrategy() {
      this.wrapper.placementModel.placementBidStrategyMappings.push({
        bidStrategyId: 0,
        bidValue: 0,
        placementId: 0,
      })
    },
    setTypeOfAd(adType) {
      this.wrapper.placementModel.adType = adType.id
    },
    removePlacementFormat(index) {
      this.wrapper.placementModel.placementFormatMappings.splice(index, 1)
    },
    removePlacementBidding(index) {
      this.wrapper.placementModel.placementBidStrategyMappings.splice(index, 1)
    },
    isFormatChecked(format) {
      const isChecked = this.wrapper.placementModel.placementFormatMappings.filter(c => c.formatId === format.id).length > 0
      this.$set(format, 'checked', isChecked)
    },
    setAdFormatsFalse() {
      this.wrapper.placementModel.placementFormatMappings = []
      this.wrapper.adFormats.forEach(format => {
        this.$set(format, 'checked', false)
      })
    },
    updatePreview() {
      let value = this.wrapper.placementModel.nativeAdTemplate != null ? this.wrapper.placementModel.nativeAdTemplate.htmlContent : ''
      this.wrapper.nativeAdProperties.forEach(x => {
        if (x.required && value.indexOf(`{{${x.propertyName}}}`) >= 0) value = value.split(`{{${x.propertyName}}}`).join(x.previewValue)
      })
    },
    changeTemplate(selectedOption) {
      this.wrapper.placementModel.nativeAdTemplate = selectedOption
      this.updatePreview()
    },
    getAdTypeIconTemporarily(adType) {
      switch (adType.id) {
        case 1:
          return 'Desktop'
        case 2:
          return 'Video'
        case 3:
          return 'Devices'
        default:
          return ''
      }
    },
    getAdTypeButtonClass(adTypeId) {
      return this.getButtonClass(adTypeId === this.wrapper.placementModel.adType)
    },
    getButtonClass(active) {
      if (active) return 'border-primary text-primary'
      return 'border'
    },
    setType(adType) {
      this.adType = adType
    },
    onAccountChange() {
      this.$router.push(`/${this.$route.params.accountId}/properties`)
    },
  },
}
</script>

<style lang="scss" >
@import '@/assets/scss/libs/_vue-multiselect.scss';
</style>
<!-- Create new scss file if you add more than two classes inside component -->

<style lang="scss" scoped>
@import '@/assets/scss/views/client/properties/properties/placement/index.scss';
#ad-formats {
    display: flex;
    flex-flow: wrap column;
    max-height: 230px;
    list-style: none;
    padding-left: 0;
    width: fit-content;
}
.vast-url-wrapper {
    display: flex;
    align-items: stretch;
    border-radius: 4px;
    overflow: hidden;
}
.vast-url-method {
    display: flex;
    align-items: center;
    padding: 0 0.75rem;
    font-weight: 600;
    font-size: 0.75rem;
    color: #fff;
    background-color: #7367f0;
    flex-shrink: 0;
}
.vast-url-code {
    flex: 1 1 auto;
    min-width: 0;
    white-space: pre-wrap;
    word-break: break-all;
    overflow-wrap: anywhere;
}
.list-group{
  .list-group-item{
    &:hover{
      background-color: #fff;
    }
  }
}
</style>
